"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SignatureV1_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureV1 = exports.parse_signature = void 0;
const error_1 = require("../error");
const secure_map_1 = require("../signature/secure_map");
const variants_1 = require("../signature/variants");
const identification_1 = require("../identification");
const predicates_1 = require("../utils/predicates");
const conversion_1 = require("../utils/conversion");
const jsrsasign_1 = require("jsrsasign");
const utils_1 = require("../utils");
/**
 * Intenta "deserializar" un mapa seguro a una firma.
 *
 * @returns La firma, o en su caso, un error
 */
function parse_signature(secure_map) {
    let res = SignatureV1.from_secure_map(secure_map);
    if (!(0, predicates_1.isError)(res)) {
        return res;
    }
    return new error_1.Error(error_1.ErrorCode.WrongStructure, "secure_map != SignatureV1");
}
exports.parse_signature = parse_signature;
let $TextEncoder = (0, utils_1.text_encoder)();
let SignatureV1 = SignatureV1_1 = class SignatureV1 extends secure_map_1.SecureMap {
    //new(): Signature<identification>;
    // Due to typescript limitation, the passed secret has a type that might not match x509certificate
    static create(args) {
        let sig = new SignatureV1_1();
        sig.inner_version = "1.0.0-alpha.1";
        if (args.custom_data == undefined) {
            args.custom_data = null;
        }
        sig.inner_custom_data = args.custom_data;
        sig.inner_method = variants_1.SignatureMethod.SHA256withRSA;
        sig.inner_encoding = variants_1.SignatureEncoding.Base64;
        let signatures = args.content.get("$signatures");
        if (signatures != undefined) {
            args.content.delete("$signatures");
        }
        let encoder = $TextEncoder; //new TextEncoder();
        // The text needs to be treated as UTF-8 string
        let bytes = encoder.encode(args.content.serialize());
        let signature_bytes = args.identification.sign(bytes, args.secret);
        if ((0, predicates_1.isError)(signature_bytes)) {
            return signature_bytes;
        }
        let signature = (0, conversion_1.bytes2Base64)(signature_bytes);
        sig.inner_signature = signature;
        sig.inner_identification = args.identification;
        // Now the actual map treatment
        sig.set("version", sig.inner_version);
        sig.set("custom_data", sig.inner_custom_data);
        sig.set("method", sig.inner_method);
        sig.set("encoding", sig.inner_encoding);
        sig.set("signature", sig.inner_signature);
        sig.set("identification", sig.inner_identification.to_string());
        // If the signature is in place, we add it to the thingy
        if (args.in_place != undefined && args.in_place) {
            if (signatures == undefined) {
                let signatures = new secure_map_1.SecureMap();
                signatures.set(args.identification.get_unique_id(), sig);
                args.content.set("$signatures", signatures);
            }
            else {
                if ((0, secure_map_1.isSecureMap)(signatures)) {
                    signatures.set(args.identification.get_unique_id(), sig);
                }
                else {
                    return new error_1.Error(error_1.ErrorCode.WrongSignaturesStructure);
                }
            }
        }
        else {
            if (signatures != undefined) {
                args.content.set("$signatures", signatures);
            }
        }
        return sig;
    }
    // TODO: quitar este método
    static create_ayuda_microsoft(content, identification, secret, method, encoding, custom_data, in_place) {
        let sig = new SignatureV1_1();
        sig.inner_version = "1.0.0-alpha.1";
        if (custom_data == undefined) {
            custom_data = null;
        }
        sig.inner_custom_data = custom_data;
        if (method == undefined) {
            sig.inner_method = variants_1.SignatureMethod.SHA256withRSA;
        }
        else {
            sig.inner_method = method;
        }
        if (encoding == undefined) {
            sig.inner_encoding = variants_1.SignatureEncoding.Base64;
        }
        else {
            sig.inner_encoding = encoding;
        }
        console.log("El JSON original, \"canonizado\" es el siguiente:");
        console.log(content.serialize() + "\n");
        console.log("Ahora, lo que se hace es quitar el campo de firma (si está presente)");
        let signatures = content.get("$signatures");
        if (signatures != undefined) {
            content.delete("$signatures");
        }
        console.log("El nuevo json en forma canónica, es el siguiente:");
        console.log(content.serialize() + "\n");
        let encoder = $TextEncoder; //new TextEncoder();
        // The text needs to be treated as UTF-8 string
        let bytes = encoder.encode(content.serialize());
        console.log("De fondo, codificamos la cadena estrictamente como UTF-8 (js usa UTF-16), lo cual da la siguiente secuencia de bytes:");
        console.log(bytes);
        console.log("\n");
        console.log("A esos bytes se les calculará el Sha256, que debe verse así:");
        let tempa = (0, conversion_1.bytes2hex)(bytes);
        let dig = new jsrsasign_1.KJUR.crypto.MessageDigest({ alg: "sha256", prov: "sjcl" });
        let res_hex = dig.digestHex(tempa);
        console.log(res_hex + "\n");
        console.log("Y de aquí siguen los dos pasos del Sha256WithRsa, PKCSV1.5 (padding y exponenciar)");
        let signature_bytes = identification.sign(bytes, secret);
        if ((0, predicates_1.isError)(signature_bytes)) {
            return signature_bytes;
        }
        if (sig.inner_encoding == variants_1.SignatureEncoding.Base64) {
            let signature = (0, conversion_1.bytes2Base64)(signature_bytes);
            sig.inner_signature = signature;
        }
        else {
            let signature = (0, conversion_1.bytes2hex)(signature_bytes);
            sig.inner_signature = signature;
        }
        sig.inner_identification = identification;
        // Now the actual map treatment
        sig.set("version", sig.inner_version);
        sig.set("custom_data", sig.inner_custom_data);
        sig.set("method", sig.inner_method);
        sig.set("encoding", sig.inner_encoding);
        sig.set("signature", sig.inner_signature);
        sig.set("identification", sig.inner_identification.to_string());
        // If the signature is in place, we add it to the thingy
        if (in_place != undefined && in_place) {
            if (signatures == undefined) {
                let signatures = new secure_map_1.SecureMap();
                signatures.set(identification.get_unique_id(), sig);
                content.set("$signatures", signatures);
            }
            else {
                if ((0, secure_map_1.isSecureMap)(signatures)) {
                    signatures.set(identification.get_unique_id(), sig);
                }
                else {
                    return new error_1.Error(error_1.ErrorCode.WrongSignaturesStructure);
                }
            }
        }
        else {
            if (signatures != undefined) {
                content.set("$signatures", signatures);
            }
        }
        return sig;
    }
    /// Creates a signature from a jsonable map
    static from_secure_map(source) {
        let sv1 = new SignatureV1_1();
        let version = source.get("version");
        let custom_data = source.get("custom_data");
        let method = source.get("method");
        let encoding = source.get("encoding");
        let signature = source.get("signature");
        let identification = source.get("identification");
        if (version == undefined || method == undefined || encoding == undefined || signature == undefined || identification == undefined) {
            return new error_1.Error(error_1.ErrorCode.MissingFields);
        }
        // Validación de versión
        if ((0, predicates_1.isString)(version)) {
            if (version != "1.0.0-alpha.1") {
                return new error_1.Error(error_1.ErrorCode.UnsupportedVersion);
            }
            sv1.set("version", version);
            sv1.inner_version = version;
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(version) != string");
        }
        // Validación de la información "custom"
        if (custom_data != undefined) {
            if ((0, secure_map_1.isSecureMap)(custom_data)) {
                sv1.set("custom_data", custom_data);
            }
            else {
                return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(custom_data) != map");
            }
        }
        // Validación del método
        if ((0, predicates_1.isString)(method)) {
            sv1.set("method", method);
            if (Object.values(variants_1.SignatureMethod).includes(method)) {
                sv1.inner_method = method;
            }
            else {
                return new error_1.Error(error_1.ErrorCode.InvalidValue, `"method" not in ${Object.values(variants_1.SignatureMethod)}`);
            }
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(method) != string");
        }
        // Validación del encoding
        if ((0, predicates_1.isString)(encoding)) {
            sv1.set("encoding", encoding);
            if (Object.keys(variants_1.SignatureEncoding).includes(encoding)) {
                sv1.inner_encoding = encoding;
            }
            else {
                return new error_1.Error(error_1.ErrorCode.InvalidValue, `"method" not in ${Object.values(variants_1.SignatureEncoding)}`);
            }
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(encoding) != string");
        }
        // Validación de la "firma"
        if ((0, predicates_1.isString)(signature)) {
            sv1.set("signature", signature);
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(signature) != string");
        }
        // Validación de la identificación
        if ((0, predicates_1.isString)(identification)) {
            sv1.set("identification", identification);
            let x_cert = identification_1.X509Certificate.from_string(identification);
            if ((0, predicates_1.isError)(x_cert)) {
                return x_cert;
            }
            sv1.inner_identification = x_cert;
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(identification) != string");
        }
        return sv1;
    }
    // creates a signature from cero
    static from_value(source) {
        return new error_1.Error(error_1.ErrorCode.Unimplemented);
    }
    /// In case one needs the current static version
    static get_static_version() {
        return "1.0.0-alpha.1";
    }
    /// Indicates if a given version is supported for an implementation
    static is_compatible(version) {
        return version == "1.0.0-alpha.1";
    }
    /**
     * Entrega la versión de la instancia de firma que llama al método.
     *
     * @returns Una cadena que representa la versión
     */
    get_version() {
        return "1.0.0-alpha.1";
    }
    /**
     * Entrega la información personalizada (en caso de existir) de la instancia de firma que llama al método.
     *
     * @returns La estructura de información personalizada, en caso de existir.
     */
    get_custom_data() {
        return this.inner_custom_data;
    }
    /**
     * Entrega la identificación de fondo que se utilizó para generar la firma.
     *
     * @returns La identificación con la que se realizó la firma
     */
    get_identification() {
        return new identification_1.IdentificationVariant(this.inner_identification);
    }
    verify_signature(message) {
        return new error_1.Error(error_1.ErrorCode.Unimplemented);
    }
};
SignatureV1 = SignatureV1_1 = __decorate([
    (0, secure_map_1.implementsSignature)()
], SignatureV1);
exports.SignatureV1 = SignatureV1;
//# sourceMappingURL=signatures.js.map